/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, November 12th 2021, 9:07:59 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import SunEditor from "suneditor-react";
import { SunEditorReactProps } from "suneditor-react/dist/types/SunEditorReactProps";
import "suneditor/dist/css/suneditor.min.css"; // Import Sun Editor's CSS File

const defaultFonts = [
  "Arial",
  "Comic Sans MS",
  "Courier New",
  "Impact",
  "Georgia",
  "Tahoma",
  "Trebuchet MS",
  "Verdana",
];

export interface WYSIWYGProps
  extends Pick<SunEditorReactProps, "defaultValue" | "onChange" | "setContents" | "appendContents"> {
  height?: SunEditorReactProps["setOptions"]["height"];
  minHeight?: SunEditorReactProps["setOptions"]["minHeight"];
}

export const WYSIWYG = ({ defaultValue, onChange, setContents, appendContents, height, minHeight }: WYSIWYGProps) => {
  const sortedFontOptions = [
    "Logical",
    "Salesforce Sans",
    "Garamond",
    "Sans-Serif",
    "Serif",
    "Times New Roman",
    "Helvetica",
    ...defaultFonts,
  ].sort();

  return (
    <SunEditor
      defaultValue={defaultValue}
      onChange={onChange}
      setContents={setContents}
      appendContents={appendContents}
      setOptions={{
        height,
        minHeight,
        buttonList: [
          ["undo", "redo"],
          ["font", "fontSize"],
          ["paragraphStyle", "blockquote"],
          ["bold", "underline", "italic", "strike", "subscript", "superscript"],
          ["fontColor", "hiliteColor"],
          ["align", "list", "lineHeight"],
          ["outdent", "indent"],

          ["table", "horizontalRule", "link", "image", "video"],
          // ['math'] //You must add the 'katex' library at options to use the 'math' plugin.
          // ['imageGallery'], // You must add the "imageGalleryUrl".
          ["fullScreen", "showBlocks", "codeView"],
          ["preview", "print"],
          ["removeFormat"],
          // ["save", "template"],
          // '/', Line break
        ], // Or Array of button list, eg. [['font', 'align'], ['image']]
        defaultTag: "div",
        showPathLabel: false,
        font: sortedFontOptions,
      }}
      setAllPlugins={false}
    />
  );
};
